import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import "../zoomable-slide/zoomable-slide";

import type {
  DiagramVisualData,
  ImageVisualData,
  SlideState,
} from "../../types.d";
import type { SlideViewMode } from "../slide/slide";

@customElement("bp-diagram-slide")
export class DiagramSlide extends LitElement {
  @property({ type: Object })
  data?: DiagramVisualData | ImageVisualData;

  @property({ type: Boolean, attribute: "hide-shadow" })
  hideShadow = false;

  @property({ type: Boolean, attribute: "hide-title" })
  hideTitle = false;

  @property({ type: Object })
  slideState?: SlideState;

  @property({ type: Boolean, attribute: "title-wraps-2-lines" })
  titleWraps2Lines = false;

  @property({ attribute: "view-mode" })
  viewMode: SlideViewMode = "default";

  render() {
    if (!this.data) return;

    const { src, alt } = this.data;

    return html`
      <bp-zoomable-slide
        view-mode="${this.viewMode}"
        ?hide-title=${this.hideTitle}
        ?hide-shadow=${this.hideShadow}
        ?title-wraps-2-lines=${this.titleWraps2Lines}
        .slideState=${this.slideState}
      >
        <div slot="title">
          <slot name="title"></slot>
        </div>
        <img slot="content" src=${src} alt=${alt} title=${alt} />
      </bp-zoomable-slide>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-diagram-slide": DiagramSlide;
  }
}
